import { useRef, useState, useCallback } from "react";
import { MoveHorizontal } from "lucide-react";
import { imgUrl } from "@/lib/api";

// Pred/Po porovnávací slider — ťahateľný deliť medzi fotkou pred a po realizácii.
// Podpora myš + dotyk (pointer events), klávesnica cez input range.
export default function BeforeAfter({ before, after, alt = "", testid = "before-after", height = "h-64 md:h-80" }) {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);

  const move = useCallback((clientX) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const pct = ((clientX - r.left) / r.width) * 100;
    setPos(Math.max(2, Math.min(98, pct)));
  }, []);

  const onPointerDown = (e) => {
    e.currentTarget.setPointerCapture?.(e.pointerId);
    move(e.clientX);
    const onMove = (ev) => move(ev.clientX);
    const onUp = () => {
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerup", onUp);
    };
    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerup", onUp);
  };

  return (
    <div ref={ref} data-testid={testid} onPointerDown={onPointerDown}
      className={`relative w-full ${height} overflow-hidden select-none touch-none border border-white/15 cursor-ew-resize bg-ink-2`}>
      {/* PO (spodná vrstva — plná) */}
      <img src={imgUrl(after)} alt={alt ? `${alt} — po` : "Po realizácii"} draggable={false}
        className="absolute inset-0 w-full h-full object-cover pointer-events-none" />
      {/* PRED (horná vrstva — orezaná clip-path podľa pozície) */}
      <div className="absolute inset-0 pointer-events-none" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={imgUrl(before)} alt={alt ? `${alt} — pred` : "Pred realizáciou"} draggable={false}
          className="absolute inset-0 w-full h-full object-cover pointer-events-none" loading="lazy" />
      </div>
      {/* deliť */}
      <div className="absolute inset-y-0 pointer-events-none" style={{ left: `${pos}%` }}>
        <div className="absolute inset-y-0 -left-px w-0.5 bg-gold shadow-[0_0_12px_rgba(212,175,55,0.8)]" />
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-10 h-10 bg-gold text-ink rounded-full flex items-center justify-center shadow-lg">
          <MoveHorizontal className="w-5 h-5" />
        </div>
      </div>
      <span className="absolute top-3 left-3 bg-ink/80 text-white text-[10px] font-bold uppercase tracking-widest px-2 py-1 pointer-events-none">Pred</span>
      <span className="absolute top-3 right-3 bg-gold text-ink text-[10px] font-bold uppercase tracking-widest px-2 py-1 pointer-events-none">Po</span>
      <input type="range" min="2" max="98" value={Math.round(pos)} onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Porovnanie pred a po" data-testid={`${testid}-range`}
        className="absolute opacity-0 inset-0 w-full h-full cursor-ew-resize" />
    </div>
  );
}
